import { useHref, useLink } from "@made-people/grease-link";
import { ButtonAsLink } from "@made-people/blueprint-button";
import { useTranslate } from "@made-people/grease-translations";
import { useLoginForm } from "./hooks/use-login-form";
import { LoginForm } from "./forms/LoginForm";

export const AccountLoginPageRoute = () => {
  const href = useHref();
  const Link = useLink();
  const translate = useTranslate();
  const form = useLoginForm({
    onSuccess: () => {
      window.location.href = href("comfort-club");
    },
  });

  return (
    <div className="mx-auto w-full max-w-screen-page-max-width md:px-component-spacing-lg xl:px-component-spacing-2xl">
      <div className="md:grid md:grid-cols-12 md:gap-x-1 min-h-[80vh]">
        <div className="md:col-start-4 md:col-span-6 w-full py-12 px-4 md:px-0">
          <LoginForm
            form={form}
            forgotPasswordAction={
              <Link
                href={href("comfort-club/reset-password")}
                className="text-sm underline"
              >
                {translate("Account_Login_ForgotPassword")}
              </Link>
            }
            signupAction={
              <ButtonAsLink
                label={translate("Account_Login_SecondaryAction")}
                link={{ href: href("comfort-club/register") }}
                variants={{ style: "outline", width: "full" }}
              />
            }
          />
        </div>
      </div>
    </div>
  );
};
